import { Box, Text, Flex, useColorMode, Code, useMediaQuery, Link } from '@chakra-ui/react';
import { ColorModeSwitcher } from './ColorModeSwitcher';
import { Imports } from './components/Imports';
import { Installation } from './components/Installation';
import { BasicUsage } from './components/BasicUsage';
import { CustomizeProgressBar } from './components/CustomizeProgressBar';
import { borderColor } from './const';
import { Examples } from './components/Examples';
import { WithOptions } from './components/WithOptions';
import { PropsTable } from './components/PropsTable';
import { OptionsTable } from './components/OptionsTable';
import { FaGithub } from 'react-icons/fa';

export const App = () => {
	const { colorMode } = useColorMode();
	const [isLargerThan891] = useMediaQuery('(min-width: 891px)');

	return (
		<div>
			<Flex justifyContent="space-between" p="10px" backgroundColor="purple.600" color="gray.200" mb="20px">
				<Box py="10px">
					<Text fontSize="2xl" fontWeight="bold">
						MS REACT PROGRESS BAR
					</Text>
				</Box>
				<Flex alignItems="center">
					<Link href="https://github.com/Ankomahene/ms-react-progress-bar" mr="20px">
						<FaGithub />
					</Link>
					<ColorModeSwitcher />
				</Flex>
			</Flex>

			<Box width="95%" m="auto">

				<Text fontSize="3xl" fontWeight="bold" py="10px">
					MS React Progress Bar
				</Text>
				<Flex alignItems='center' justifyContent="space-between">
					<Flex>
						<Box mr="10px" my="20px"><img alt="NPM" src="https://img.shields.io/npm/dw/ms-react-progress-bar?color=%236b46c1&style=for-the-badge" /></Box>
						<Box mr="10px" my="20px"><img alt="NPM" src="https://img.shields.io/npm/l/ms-react-progress-bar?color=%236b46c1&style=for-the-badge" /></Box>
						<Box mr="10px" my="20px"><img alt="NPM" src="https://img.shields.io/npm/v/ms-react-progress-bar?color=%236b46c1&label=LATEST%20VERSION&style=for-the-badge" /></Box>
					</Flex>
				</Flex>
				<Box mb="20px">
					<img alt="MS React Progress Bar CI" src="https://github.com/Ankomahene/ms-react-progress-bar/actions/workflows/main.yml/badge.svg" />
				</Box>
				<Flex flexWrap="wrap" my="20px">
					<Box w={isLargerThan891 ? '40%' : '100%'} p="10px">
						<Box mt="10px">
							<Code py="2px" px="10px">
								ms-react-progress-bar
							</Code>{' '}
							is a simple standalone React component that is used to create customized progress bars for react
							projects.
						</Box>
						<Examples />
						<Text fontSize="2xl" fontWeight="bold" py="10px">
							Installation
						</Text>
						<Installation manager="npm" />
						<Installation manager="yarn" />
						<Imports />
					</Box>
					<Box w={isLargerThan891 ? '60%' : '100%'}>
						<Text fontSize="2xl" fontWeight="bold" py="10px">
							The Playground
						</Text>
						<Box border="1px" borderColor={borderColor[colorMode]} borderRadius="sm">
							<CustomizeProgressBar />
						</Box>
					</Box>
				</Flex>
				<Box>
					<BasicUsage />
					<WithOptions />
				</Box>
				<Box>
					<PropsTable />
					<OptionsTable />
				</Box>
			</Box>
		</div>
	);
};
